export default "__VITE_ASSET__BnRCHCAP__"